module.exports = __webpack_public_path__ + "img/image-oval-left-bottom.46bd0b5.jpg";